import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import TitlePage from "./../../../common/TitlePage";
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginBottom: 20,
        borderRadius: 10,
        '&:not(:first-child)': {
            borderBottom: 0,
        },
    },

    container: {
        padding: "20px 40px",
        background: "#f2f4f6",
        borderRadius: 15,
        marginBottom: 90,
        [theme.breakpoints.down("md")]: {
            width: "95%",
            margin: "0 auto",
            marginBottom: 30,
            padding: "5px 10px"
        },

    },
}));

export default function ControlledAccordions() {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={`${classes.root} container-md`}>
                <div className={`text-center mb-3`}>
                    <TitlePage position="bottomCenter">
                        نحوه دریافت کد بورس کالا
                    </TitlePage>
                </div>
                <div className={`w-100`}>
                    <video width="100%" controls preload="none" poster="/assets/images/videoposter.png" >
                        <source src="/assets/video/ebgo.mp4" type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    );
}

